import DriContractDebugPage from './DriContractDebugPage';

export default DriContractDebugPage;
